module.exports = __webpack_public_path__ + "img/focus_personnal.05a4faa0.svg";